'use client';

import { Box, Flex, IsVisible } from '@packages/ui';
import Image from 'next/image';

import ImageLoader from 'components/utils/ImageLoader';
import { EActiveDomains } from 'enums/activeDomain';

interface IImagesComponentProps {
  activeDomain: EActiveDomains;
}

function Images({ activeDomain }: IImagesComponentProps) {
  return (
    <Flex className="gap-8 w-full py-8 items-center justify-center">
      <Box className="ml-[15px]">
        <Image
          alt="Fixxer logo"
          className="mx-auto"
          height={150}
          loader={ImageLoader}
          priority
          src="/images/fixxer-website/jaimy-logo.png"
          width={150}
        />
      </Box>
      <Box>
        <IsVisible
          when={
            activeDomain === EActiveDomains.External ||
            activeDomain === EActiveDomains.Dev
          }
        >
          <Image
            alt="Fixxer logo"
            className="mx-auto"
            height={150}
            loader={ImageLoader}
            priority
            src="/images/fixxer-website/euro-assistance-logo.webp"
            width={130}
          />
        </IsVisible>
        <IsVisible
          when={
            activeDomain === EActiveDomains.B2B ||
            activeDomain === EActiveDomains.Dev
          }
        >
          <Image
            alt="B2B logo"
            className="mx-auto"
            height={140}
            loader={ImageLoader}
            priority
            src="/images/fixxer-website/B2B_Logo.png"
            width={100}
          />
        </IsVisible>
      </Box>
    </Flex>
  );
}

export default Images;
